
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import {Prop} from 'vue-property-decorator';

    @Component
    export default class ChallengeItemStats extends Vue {
        @Prop({required: true, default: 'fa-star'})
        icon!: string;

        @Prop({required: true, default: ''})
        text!: string;
    }

